import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Lead_New } from 'app/shared/models/leads_new.model';
import { Outsource_Lead } from 'app/shared/models/outsource_lead.model';
import { ApiService } from 'app/shared/services/api.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-outsourcelead',
  templateUrl: './add-outsourcelead.component.html',
  styleUrls: ['./add-outsourcelead.component.scss']
})
export class AddOutsourceleadComponent implements OnInit {

  out_source_lead= new Outsource_Lead();  
  lead = new Lead_New();

  outsource_lead_model={
    
      title: '',
      coverletter:'' ,
      date:'',
      source: '63ef45065fb91668b7f123c3',
      links: '',
      notes:'' ,
      admin_notes: '',
      channelId:'' ,
      type: '63e39dd62052e0098e18e015',
      lead_status: '',
      lead_stage:'' ,
      last_activedate: '',
      lastresponse: '',
      ip: '',
      next_action: '63e39c0d2052e0098e18dfe5',
      task_ids:'' ,
      outsource:'63ef45065fb91668b7f123c3',
      technology:[],
      is_invited:'',
      platform:''
  }
 
  typeList=[]
  sourceList = [];
  nextactionList = []
  leadstatuslist=[]
  leadstageList=[]

  lead_status_tagcat_id = '63e391812052e0098e18de76'
  lead_stage_tagcat_id = '63e397c12052e0098e18df3d'
  source_tagcat_id = '63ef44bb5fb91668b7f123ba'
  nextaction_tagcat_id = '63e39b572052e0098e18dfc2'
  type_tagcat_id = '63e39cf92052e0098e18e003'

  selected_nextaction='63e39c0d2052e0098e18dfe5'
  selected_source='63ef45065fb91668b7f123c3'
  selected_lead_status='63e396de2052e0098e18deec'
  selected_lead_stage='63e391a22052e0098e18de7f'
  selected_type='63e39dd62052e0098e18e015'
  currentUrl:any
  ipAddress:any
  outSource_lead_id:any
  currentDate:string
  channelList=[]
  channel_id_upwork='63f89955c3648e0879c3e068'
  channel_id_fiverr='63f89982c3648e0879c3e06f'
  channel_id_direct='63f899a5c3648e0879c3e076'
  newList=[
    {name:'no'},
    {name:'yes'}
  ] 
  selected_Invite='no'
  selected_channel=null

  technology_catId='6319d5025ab9e462a96cfbba'
  technology_List=[]
  selectedTechnology=null

  tech_idd=''
  source_name:any = 'upwork'
    constructor(public apiService: ApiService,private deviceService: DeviceDetectorService,
              private http: HttpClient,public toastr: ToastrService,
              private route: Router,private activerouter: ActivatedRoute,){
                this.currentUrl = this.activerouter.snapshot.routeConfig.path
                if(this.currentUrl ==='outsource-lead-edit/:id'){
                  this.activerouter.paramMap.subscribe(params => { 
                    this.outSource_lead_id = params.get('id');  
                  }) 
                }

              }

  ngOnInit() {
    if(this.currentUrl ==='add-outsource-lead'){
      this.currentDate = new Date().toISOString().substring(0, 10);
      this.outsource_lead_model.date=this.currentDate
      this.outsource_lead_model.last_activedate=this.currentDate
    }
    if(this.outSource_lead_id){
      this.getOutSourceLeadById()
      if(this.source_name == 'upwork'){
        this.getChannelList(this.channel_id_upwork,this.selectedTechnology)
      }
      else if(this.source_name == 'fiverrr'){
        this.getChannelList(this.channel_id_fiverr,this.selectedTechnology)
      }
      else if(this.source_name == 'direct'){
        this.getChannelList(this.channel_id_direct,this.selectedTechnology)
      }
    }
    this.getSource()
    this.getNextActionTags()
    this.getLeadStatus()
    this.getLeadStage()
    this.getTypeTags()
    this.getIPAddress()
    this.getTechnologyList()

  }
  getOutSourceLeadById() {
    this.apiService.getOutsourceLeadsById(this.outSource_lead_id).subscribe((res: any) => {
      
      for(let item of res.data){
        this.out_source_lead = item
      }
      // console.log('this.out_source_lead',this.out_source_lead)
      // ---------- Step 1 ------------------------------------
      this.outsource_lead_model.title=this.out_source_lead?.leads?.title
      this.outsource_lead_model.coverletter=this.out_source_lead?.coverletter
      this.outsource_lead_model.date=this.out_source_lead?.date
      this.selected_channel=this.out_source_lead?.channelId?._id
      this.selected_source=this.out_source_lead?.outsource._id 
      this.outsource_lead_model.links=this.out_source_lead?.links
      this.outsource_lead_model.notes=this.out_source_lead?.notes
      this.outsource_lead_model.admin_notes=this.out_source_lead?.admin_notes

      // ----------- Step 2 -----------------------------------------
      this.outsource_lead_model.ip=this.out_source_lead?.leads?.ip
      this.outsource_lead_model.last_activedate=this.out_source_lead?.leads?.last_activedate
      this.outsource_lead_model.lastresponse=this.out_source_lead?.leads?.lastresponse
      this.selected_lead_stage=this.out_source_lead?.leads?.lead_stage?._id
      this.outsource_lead_model.lead_stage=this.selected_lead_stage
      this.selected_lead_status=this.out_source_lead?.leads?.lead_status?._id
      this.outsource_lead_model.lead_status=this.selected_lead_status
      this.selected_type=this.out_source_lead?.leads?.type?._id
      this.selected_nextaction=this.out_source_lead?.leads?.next_action?._id
      this.selected_Invite=this.out_source_lead?.is_invited
      // console.log('selected_Invite',this.selected_Invite)
      this.selectedTechnology=this.out_source_lead?.technology?._id
    })
  }
  getChannelList(id,tech_id){
    this.apiService.getChannelsByCategory(id,tech_id).subscribe((res:any)=>{
      this.channelList=res.data
    })
  }
  getChangeChannelId(event){
    this.outsource_lead_model.channelId= this.selected_channel
  }
  getTechnologyList(){
    this.apiService.getTagByTagCatgoryId(this.technology_catId).subscribe((res:any)=>{
      this.technology_List=res.data.slice(0, 4)
      if(this.outSource_lead_id){
        this.getTechnologyId('')
      }
    })
   }
   getTechnologyId(event){
    this.selectedTechnology
    if(this.source_name == 'upwork'){
      this.getChannelList(this.channel_id_upwork,this.selectedTechnology)
    }
    else if(this.source_name == 'fiverrr'){
      this.getChannelList(this.channel_id_fiverr,this.selectedTechnology)
    }
    else if(this.source_name == 'direct'){
      this.getChannelList(this.channel_id_direct,this.selectedTechnology)
    }
   }
  getTypeTags() {
    this.apiService.getTagByTagCatgoryId(this.type_tagcat_id).subscribe((res: any) => {
      this.typeList = res.data
    })
  }
  getChangeType(event) {
    this.selected_type
    this.outsource_lead_model.type=this.selected_type
  }
  getLeadStatus() {
    this.apiService.getTagByTagCatgoryId(this.lead_status_tagcat_id).subscribe((res: any) => {
      this.leadstatuslist = res.data
    })
  }
  getLeadStatusId(event: any) {
    this.selected_lead_status
    this.outsource_lead_model.lead_status=this.selected_lead_status
  }
  getLeadStage() {
    this.apiService.getTagByTagCatgoryId(this.lead_stage_tagcat_id).subscribe((res: any) => {
      this.leadstageList = res.data
    })
  }
  getLeadStageId(event: any) {
    this.selected_lead_stage
    this.outsource_lead_model.lead_stage=this.selected_lead_stage
  }
  getSource(){
    this.apiService.getTagByTagCatgoryId(this.source_tagcat_id).subscribe((res: any) => {
      this.sourceList = res.data
    })
  }
  getSourceId(event:any){
    this.source_name=event.name
    this.selected_source
    this.outsource_lead_model.outsource=this.selected_source
    if(this.source_name == 'upwork'){
      this.getChannelList(this.channel_id_upwork,this.selectedTechnology)
    }
    else if(this.source_name == 'fiverrr'){
      this.getChannelList(this.channel_id_fiverr,this.selectedTechnology)
    }
    else if(this.source_name == 'direct'){
      this.getChannelList(this.channel_id_direct,this.selectedTechnology)
    }
  }
  getChangeListId(event){
  this.selected_Invite=event.name
  }

  getNextActionTags() {
    this.apiService.getTagByTagCatgoryId(this.nextaction_tagcat_id).subscribe((res: any) => {
      this.nextactionList = res.data
    })
  }
  getChangeNextAction(event) {
    this.selected_nextaction
    this.outsource_lead_model.next_action=this.selected_nextaction
  }
  getDevice(): any {
    return this.deviceService.getDeviceInfo();
  }
  getIPAddress() {
      this.http.get("http://api.ipify.org/?format=json").subscribe((res: any) => {
      this.ipAddress = res.ip;
      this.outsource_lead_model.ip=this.ipAddress
      this.outsource_lead_model.platform=JSON.stringify(this.getDevice())
    });
  }
  outsourceSubmit(){
    this.outsource_lead_model.source=this.outsource_lead_model.outsource
    this.outsource_lead_model.is_invited=this.selected_Invite
    this.outsource_lead_model.technology=this.selectedTechnology
    if(this.outSource_lead_id){
      this.apiService.updateOutSourceLeads(this.outSource_lead_id,this.outsource_lead_model).subscribe((res:any)=>{
        if(res.statusCode === 200){
          this.toastr.success("Updated Successfully")
          this.route.navigate(['/leads/outsource-leads'])
        }
        else{
          this.toastr.error(res.error)
        }
      })
    }
    if(!this.outSource_lead_id){
      this.outsource_lead_model.ip=this.ipAddress
      this.outsource_lead_model.technology=this.selectedTechnology
      this.outsource_lead_model.is_invited=this.selected_Invite
      this.outsource_lead_model.lead_status='63e396de2052e0098e18deec' // Open Status
      this.outsource_lead_model.lead_stage='63e391a22052e0098e18de7f' // Prospect Stage
      this.apiService.createOutSourceLeads(this.outsource_lead_model).subscribe((res:any)=>{
        if(res.statusCode === 200){
          this.toastr.success("Created Successfully")
          this.route.navigate(['/leads/outsource-leads'])
        }
        else{
          this.toastr.error(res.error)
        }
      })
    }
  }
 
}
